import { createUseStyles } from '../../theme/theming';

const useSectionStyles = createUseStyles((theme) => ({
  section: {
    padding: ({ isMobile } = {}) =>
      isMobile
        ? `${theme.spacing.padding.regular}px 0px ${theme.spacing.padding.regular}px ${theme.spacing.padding.small}px`
        : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
    background: `linear-gradient(180deg, ${theme?.colors?.background2} 50%, #FFFFFF 50%)`,

    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    }
    // '& h2,& h3': {
    //   fontWeight: '500',
    //   '& b,& strong': {
    //     fontWeight: '700'
    //   }
    // }
  },
  sectionContainer: {
    margin: '0 auto',
    maxWidth: ({ containerWidth } = {}) => containerWidth
  },

  content: {
    position: 'relative'
  },

  subTitleHeading: {
    width: '100%',
    fontSize: theme.typography.fontSize.subHead,
    color: theme?.colors?.font2,
    textTransform: 'uppercase',
    textAlign: 'left',
    lineHeight: '20px',
    letterSpacing: '3px',
    wordBreak: 'break-word'
  },
  heading: {
    margin: `0px 0 ${theme.spacing.margin.tiny}px`,
    fontSize: theme.typography.fontSize.h2,
    width: '100%',
    lineHeight: '70px',
    color: theme?.colors?.font2,
    textAlign: 'left',
    wordBreak: 'break-word'
  },

  // sliderContainer: {
  //   marginLeft: '-10px',
  //   marginRight: '-70px'
  // },

  card: {
    background: theme?.colors?.white,
    boxShadow: theme?.shadows?.primary,
    borderRadius: theme.shape.borderRadius.large,
    margin: ({ slidesToShow, cardsCount } = {}) =>
      cardsCount > slidesToShow ? `6px 25px 6px 0px` : `6px 0 6px 0`,
    height: 'calc(100% - 12px)'
  },
  cardContent: {
    padding: '24px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  cardHeading: {
    textAlign: 'center',
    fontSize: theme.typography.fontSize.h6,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme?.colors?.lightblack,
    margin: `16px 0px`,
    wordBreak: 'break-word'
  },
  imageContainer: {
    textAlign: 'center',
    width: '96px',
    height: '96px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    background: theme?.colors?.background2
  },
  buttonContainerClass: {
    marginRight: theme.spacing.margin.regular,
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing.margin.tiny
  },
  cardPara: {
    textAlign: 'center',
    fontSize: theme.typography.fontSize.body,
    lineHeight: '22px',
    color: theme?.colors?.gray,
    margin: '0',
    wordBreak: 'break-word'
  },
  contentRow: {
    display: 'grid',
    gridTemplateColumns: ({ slidesToShow } = {}) =>
      `repeat(${slidesToShow},minmax(0, 1fr))`,
    gap: '0 40px'
  },

  '@media screen and (max-width: 767px)': {
    heading: {
      textAlign: 'center',
      fontSize: '20px',
      margin: `0px 0 ${theme.spacing.margin.tiny}px`,
      lineHeight: '24px',
      padding: '0'
    },
    subTitleHeading: {
      textAlign: 'center'
    },
    sliderContainer: {
      marginLeft: '-6px',
      marginRight: '-20px'
    },
    imageContainer: {
      width: '72px',
      height: '72px'
    },
    card: {
      width: 'calc(100% - 8px)',
      margin: ({ slidesToShow, cardsCount } = {}) =>
        cardsCount > slidesToShow ? `6px 2px 6px 6px` : `6px 0 6px 0`
    },
    cardHeading: {
      fontSize: '18px'
    },
    cardContent: {
      padding: '16px'
    }
  }
}));

export default useSectionStyles;
